import React from 'react';

import type { GetProudPartnersCreatorsLogosResult } from '../CreatorPage/CreatorPage.types';
import { SemboImage } from '../SemboImage/SemboImage';
import { ProudPartnersCreatorsLogosWrapper } from './ProudPartnersCreatorsLogos.styles';

type Props = {
  proudPartners: GetProudPartnersCreatorsLogosResult;
};

export const ProudPartnersCreatorsLogos = ({ proudPartners }: Props) => (
  <ProudPartnersCreatorsLogosWrapper>
    {proudPartners.map((partner, index) => {
      return (
        <SemboImage
          key={index}
          sanityImage={{
            ...partner.logo,
            description: partner.altText ?? partner.logo.description,
          }}
          wrapperStyle={{
            height: '40px',
            width: 'auto',
          }}
          xs="20vw"
          style={{
            objectFit: 'contain',
            height: '40px',
          }}
        />
      );
    })}
  </ProudPartnersCreatorsLogosWrapper>
);
